import React from "react";
import "../assets/css/AccountsPayable.css";

function AccountsPayable() {
  return (
    <div className="accounts-payable-placeholder">
      <p>Accounts payable - content coming soon.</p>
    </div>
  );
}

export default AccountsPayable;
